import { render, staticRenderFns } from "./NewAcc.vue?vue&type=template&id=2bad2b33&scoped=true"
import script from "./NewAcc.vue?vue&type=script&lang=js"
export * from "./NewAcc.vue?vue&type=script&lang=js"
import style0 from "./NewAcc.vue?vue&type=style&index=0&id=2bad2b33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad2b33",
  null
  
)

export default component.exports